<script>
import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    if (this.chartdata) {
      this.renderChart(this.chartdata, this.options);
    }
  },
  watch: {
    chartdata: {
      handler(newVal) {
        if (newVal) {
          this.renderChart(newVal, this.options);
        }
      },
      deep: true,
    },
  },
};
</script>
